// ===========================================
// konakla - Guvenli ic yonlendirme
// ===========================================
//
// NEDEN VAR (O-2): `/auth/callback` ve `/auth`, giris sonrasi kullaniciyi
// `?redirect=` parametresindeki adrese gonderiyor. Callback'teki guard suydu:
//
//   if (!redirect.startsWith("/") || redirect.startsWith("//")) -> "/dashboard"
//
// Bu guard METIN ONEKINE bakiyor, oysa karari veren sey `new URL()`'in nasil
// COZDUGU. WHATWG URL ayristiricisi ters bolu (`\`) karakterini egik cizgi gibi
// isler ve TAB/CR/LF karakterlerini sessizce atar. Canlida olculdu (2026-08-22):
//
//   /auth/callback?redirect=/%5Cevil.example    -> 307 -> https://evil.example/
//   /auth/callback?redirect=/%5C/evil.example   -> 307 -> https://evil.example/
//   /auth/callback?redirect=/%09/evil.example   -> 307 -> https://evil.example/  (TAB)
//
// Yani `konakla.co` baglantisina tiklayan kullanici, giris yaptiktan hemen
// SONRA saldirganin sitesine dusuyordu -- kimlik avi icin en elverisli an,
// cunku kullanici az once guvendigi markaya giris yapmis oluyor.
//
// IKINCI VEKTOR (raporda yoktu): `app/auth/page.tsx` `redirect` parametresini
// HIC dogrulamadan `router.push()`'a veriyordu -- orada guard bile yoktu.
//
// COZUM: karari metin oneki degil, URL COZUMLEMESI versin. Girdi sabit bir
// sentinel origin'e gore cozulur; sonuc o origin'de KALMIYORSA reddedilir.
// Boylece `\`, TAB, `//`, `https:`, `javascript:` ve daha bilmedigimiz
// ayristirici incelikleri tek kuralla kapanir.

/**
 * Cozumleme tabani. Gercek site adresi DEGIL, bilerek: kural "ayni origin'de
 * kaldi mi" oldugu icin taban sabit olmali; istek origin'ine baglamak
 * gereksiz ve preview/production'da farkli davranir.
 */
const SENTINEL_ORIGIN = "https://konakla.internal";

/**
 * Girdide bulunmasi tek basina reddetme sebebi olan karakterler:
 * ters bolu ve tum kontrol karakterleri (TAB, CR, LF, DEL dahil).
 */
const TEHLIKELI_KARAKTERLER = /[\\\u0000-\u001F\u007F]/;

/**
 * Bir `?redirect=` degerini **kesinlikle site icinde kalan** bir yola cevirir.
 *
 * Sorgu dizesi ve `#` parcasi KORUNUR -- `/profile?tab=subscription#fatura`
 * gibi mesru hedefler calismaya devam etmeli.
 *
 * @returns Guvenli ic yol, ya da girdi guvenli degilse `fallback`.
 */
export function safeInternalPath(
  raw: string | null | undefined,
  fallback: string = "/dashboard"
): string {
  if (!raw || typeof raw !== "string") return fallback;

  // 1) Erken ret -- ters bolu ve kontrol karakterleri (TAB/CR/LF dahil).
  //    URL ayristiricisi bunlari "temizledigi" icin asagidaki origin kontrolu
  //    de yakalar; yine de niyeti acikca reddediyoruz.
  if (TEHLIKELI_KARAKTERLER.test(raw)) return fallback;

  // 2) Site ici yol her zaman tek `/` ile baslar. `//host` protokole-goreli
  //    adrestir ve disari cikar.
  if (!raw.startsWith("/") || raw.startsWith("//")) return fallback;

  // 3) ASIL KURAL: coz ve origin'de kaldi mi bak.
  let cozulmus: URL;
  try {
    cozulmus = new URL(raw, SENTINEL_ORIGIN);
  } catch {
    return fallback;
  }
  if (cozulmus.origin !== SENTINEL_ORIGIN) return fallback;

  return `${cozulmus.pathname}${cozulmus.search}${cozulmus.hash}`;
}
